import React, { Suspense, useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';
const LazyLottieComponent = /*#__PURE__*/React.lazy(() => import('lottie-react'));
const FlowCardMedia = _ref => {
  let {
    animationData
  } = _ref;
  const [animationDataState, setAnimationDataState] = useState(null);
  useEffect(() => {
    const loadAnimationData = async () => {
      try {
        var _animation$animation;
        const animation = await import("app/assets/lotties/".concat(animationData));
        setAnimationDataState((_animation$animation = animation.animation) !== null && _animation$animation !== void 0 ? _animation$animation : animation.default);
      } catch (error) {
        console.error('Failed to load animation data', error);
      }
    };
    loadAnimationData();
  }, [animationData]);
  const LottiePlaceholder = /*#__PURE__*/React.createElement(Skeleton, {
    variant: "rectangular",
    style: {
      width: '100%',
      paddingBottom: '66.66%'
    }
  });
  const Lottie = animationDataState ? /*#__PURE__*/React.createElement(Suspense, {
    fallback: LottiePlaceholder
  }, /*#__PURE__*/React.createElement(LazyLottieComponent, {
    animationData: animationDataState
  })) : LottiePlaceholder;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    },
    "data-sentry-component": "FlowCardMedia",
    "data-sentry-source-file": "OnboardingFlowCardMedia.tsx"
  }, Lottie);
};
export default FlowCardMedia;